export const SHAREPOINT_ALM_DOCS_URL = 'https://learn.microsoft.com/en-us/sharepoint/dev/apis/alm-api-for-spfx-add-ins';
export const SHAREPOINT_SITE_COLLECTION_APP_CATALOG_DOCS_URL =
  'https://learn.microsoft.com/en-us/sharepoint/dev/general-development/site-collection-app-catalog';
